import BaseService from "../../../BaseService";
const { http } = BaseService();
const controller = "LoaiPhuCap";
//API

export function LoaiPhuCapGetAll(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/GetAll",
    method: "get",
    data,
  });
}

export function LoaiPhuCapCreate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/Create",
    method: "post",
    data,
  });
}

export function LoaiPhuCapUpdate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/Update",
    method: "post",
    data,
  });
}

export function LoaiPhuCapDelete(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/Delete",
    method: "post",
    data,
  });
}
